import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessHelpCategories, canAccessInterestGroups } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { GroupDetailsPage } from "./pages/group-details/GroupDetailsPage";
import { CreateHelpCategoryPage } from "./pages/help-category/CreateHelpCategoryPage";
import { EditHelpCategoryPage } from "./pages/help-category/EditHelpCategoryPage";
import { HelpCategoryListPage } from "./pages/help-category/HelpCategoryListPage";
import { CreateInterestGroupPage } from "./pages/interest-group/CreateInterestGroupPage";
import { EditInterestGroupPage } from "./pages/interest-group/EditInterestGroupPage";
import { InterestGroupListPage } from "./pages/interest-group/InterestGroupListPage";
import { CreateResidentGroupPage } from "./pages/resident-group/CreateResidentGroupPage";
import { EditResidentGroupPage } from "./pages/resident-group/EditResidentGroupPage";
import { helpCategoriesRoutes, interestGroupsRoutes } from "./routes";

export const helpCategoriesRoute = [
  {
    path: helpCategoriesRoutes.list,
    element: (
      <RequireAuth permission={canAccessHelpCategories}>
        <HelpCategoryListPage />
      </RequireAuth>
    ),
  },
  {
    path: helpCategoriesRoutes.create,
    element: (
      <RequireAuth permission={(x) => x.isAdmin && x.community.canCreateGroup}>
        <CreateHelpCategoryPage />
      </RequireAuth>
    ),
  },
  {
    path: helpCategoriesRoutes.details,
    element: <GroupDetailsPage />,
  },
  {
    path: helpCategoriesRoutes.edit,
    element: <EditHelpCategoryPage />,
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];

export const interestGroupsRoute = [
  {
    path: interestGroupsRoutes.list,
    element: (
      <RequireAuth permission={canAccessInterestGroups}>
        <InterestGroupListPage />
      </RequireAuth>
    ),
  },
  {
    path: interestGroupsRoutes.create,
    element: (
      <RequireAuth permission={(x) => x.community.canCreateGroup}>
        <CreateInterestGroupPage />
      </RequireAuth>
    ),
  },
  {
    path: helpCategoriesRoutes.details,
    element: <GroupDetailsPage />,
  },
  {
    path: interestGroupsRoutes.edit,
    element: <EditInterestGroupPage />,
  },
  {
    path: interestGroupsRoutes.createResidentGroup,
    element: (
      <RequireAuth permission={(x) => x.community.canCreateGroup}>
        <CreateResidentGroupPage />
      </RequireAuth>
    ),
  },
  {
    path: interestGroupsRoutes.editResidentGroup,
    element: <EditResidentGroupPage />,
  },
  { path: "*", element: <ErrorPage status={404} /> },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
